import React, { useEffect, useState, useCallback } from 'react';
import { useNavigate } from 'react-router';
import axios from 'axios';
import { clientNetwork, stacksApi } from '../../lib/constants';
import { fetchData, getNames } from '../../services/stacks';
import { BiGift, BiCopy } from "react-icons/bi";
import { HiOutlineUserRemove } from "react-icons/hi";
import { removeFromFollowing } from '../../services/profile';
import GiftingModal from '../../components/modal/GiftingModal';
import NFTAvatar from '../../components/avatar/NFTAvatar';
import './style.scss';
import Alert from '@mui/material/Alert';


const Following = ({ userSettings }) => {
  const navigate = useNavigate();
  const [contacts, setContacts] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [showGiftingModal, setShowGiftingModal] = useState(false);
  const [selectedPrincipal, setSelectedPrincipal] = useState(null);
  // const [authorStorageUrl, setAuthorStorageUrl] = useState(null);
  // const [Bns, setBns] = useState('');

  const altOrigin = window.location.origin;

  useEffect(() => {
    const fetchFollowingData = async () => {
      const contactList = await fetchData('followinglist.json');
      console.log(contactList);
      if (contactList.success && Array(contactList.result).length > 0) {
        const contactData = await Promise.all(
          Array(contactList.result).map(async (obj) => {
            const list = await Promise.all(
              Object.keys(obj).map(async (address) => {
                const name = await getNames(address);
                const shortendPrincipal =
                  String(address).slice(0, 5) +
                  '...' +
                  String(address).slice(address.length - 5, address.length);

                try {
                  const { data: { zonefile } } = await axios.get(`${userSettings?.stacksApi || stacksApi[clientNetwork]}/v1/names/${name.names[0]}/zonefile`);
                  const profileUrl = new RegExp(/https:\/\/(.*)json/).exec(zonefile)[0];
                  const profileJson = await axios.get(profileUrl);
                  const storageUrl = profileJson.data[0].decodedToken.payload.claim.apps[altOrigin];

                  return {
                    principalAddress: address,
                    principalShort: shortendPrincipal,
                    Bns: name.success ? name.names[0] : 'No BNS',
                    storageUrl: storageUrl,
                  };
                } catch (error) {
                  console.error('Error fetching storageUrl:', error);
                  return null; // Handle error accordingly
                }
              })
            );
            return list.filter(item => item !== null);
          })
        );
        setContacts(contactData.flat());
        setIsLoading(false);
      }
    };

    if (isLoading) {
      fetchFollowingData();
      setIsLoading(false);
    }
  }, [isLoading, altOrigin, userSettings]);

  const handleUnfollowClick = async (authorPrincipal) => {
    removeFromFollowing(authorPrincipal);
    setContacts((prevContacts) =>
      prevContacts.filter((contact) => contact.principalAddress !== authorPrincipal)
    );
  };

  const handleGiftClick = (principalAddress) => {
    setSelectedPrincipal(principalAddress);
    setShowGiftingModal(true);
  };

  const handleCopyClick = (principalAddress) => {

  };


  const redirectToProfile = useCallback((val) => {
    navigate(`/${val}`);
  }, [navigate]);

  return (
    <>
      <div className="contactsContainer">
        <Alert severity="info" color="warning">
          View and Manage Your Follows
        </Alert>
        <div className="button-container">
          {/* <button className="unfollow-all-button" onClick={handleUnfollowAllClick}>
            Unfollow All
            </button> */}
        </div>
        <ul id="followingList">
          {contacts.map(({ principalAddress, Bns, principalShort, storageUrl }) => {
            return (
              <li
                id="followingListItem"
                key={principalAddress}
              >
                <div className="following-avatar" onClick={() => redirectToProfile(principalAddress)}>
                  {/* <AdvancedDeruptar authorPrincipal={String(principalAddress)} /> */}
                  <NFTAvatar authorPrincipal={String(principalAddress)} AppStoragePath={storageUrl} authorName={Bns} userSettings={userSettings} />
                </div>
                <div id="follow-bio">
                  <p>{Bns}</p>
                  <p>{`${principalShort}`}</p>
                  <p id='actions-container'>
                    <button className="action-button" onClick={() => handleUnfollowClick(principalAddress)}><HiOutlineUserRemove /> </button>
                    <button className="action-button" onClick={() => handleCopyClick(principalAddress)}><BiCopy /> </button>
                    <button className="action-button" onClick={() => handleGiftClick(principalAddress)}><BiGift /> </button>
                  </p>
                </div>
              </li>
            );
          })}
        </ul>
      </div>
      {showGiftingModal && (
        <GiftingModal
          show={showGiftingModal}
          setShow={setShowGiftingModal}
          close={() => setShowGiftingModal(false)}
          authorPrincipal={selectedPrincipal}
          giftVia={selectedPrincipal}
          userSettings={userSettings}
        />
      )}
    </>
  );
};

export default Following;
